export default __webpack_public_path__ + "static/media/corporateLogo.4e415904.png";